import React, { useEffect } from "react";
import Shop from "../../pages/Shop";
import Login from "../../pages/Login";
import ShopList from "../../pages/Shop/ShopList";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Migration from "../../pages/migration";
import ShopCreate from "../../pages/Shop/ShopCreate";
import ShopListSub from "../../pages/Shop/ShopListSub";
import ShopCreateSub from "../../pages/Shop/ShopCreateSub";
import { Toaster } from "react-hot-toast";
import CleanDataBase from "../../pages/clean/CleanDataBase";
import HardDelete from "../../pages/harddelete/HardDelete";
import SyncShop from "../../pages/Sync/SyncShop";
import VersionList from "../../pages/Version/VersionList";
import CreateUpdateVersion from "../../pages/Version/CreateUpdateVersion";

const PrivateRoute = (props: any) => {
  const token = localStorage.getItem("token");
  if (token !== null && token !== undefined) {
    return (
      <>
        <Header />
        <Sidebar />
        <Route
          exact={true}
          path={props.path}
          component={props.component}
          render={() => <Redirect to={"/shop"} />}
        />
      </>
    );
  } else {
    return <Redirect to={"/login"} />;
  }
};

const Layout = (props: any) => {
  return (
    <>
      <Router>
        <div className="page-wrapper">
          <div className="nav-backdrop">
            <a href="#"></a>
          </div>
          <section className="wrapper">
            <div className="main-content">
              <Switch>
                <PrivateRoute path="/" exact component={ShopList} />
                <PrivateRoute path="/" exact component={Sidebar} />
                <PrivateRoute path="/shop" exact component={ShopList} />
                <PrivateRoute
                  path="/shoplist/:username"
                  exact
                  component={ShopListSub}
                />
                <PrivateRoute path="/shop/add" exact component={ShopCreate} />
                <PrivateRoute
                  path="/shop/add/:username"
                  exact
                  component={ShopCreateSub}
                />
                <PrivateRoute path="/shop/edit/:id" exact component={Shop} />
                <PrivateRoute path="/migration" exact component={Migration} />
                <PrivateRoute path="/clean" exact component={CleanDataBase} />
                <PrivateRoute path="/harddelete" exact component={HardDelete} />
                <PrivateRoute path="/sync" exact component={SyncShop} />
                <PrivateRoute path="/version" exact component={VersionList} />
                <PrivateRoute
                  path="/version/add"
                  exact
                  component={CreateUpdateVersion}
                />
                <PrivateRoute
                  path="/version/edit/:type/:number"
                  exact
                  component={CreateUpdateVersion}
                />
                <Route exact={true} path="/login" component={Login} />
              </Switch>
            </div>
          </section>

          <Footer />
        </div>
        <Toaster
          position="top-center"
          containerStyle={{ marginTop: "50px" }}
          toastOptions={{ duration: 3000 }}
          reverseOrder={false}
        />
      </Router>
    </>
  );
};

export default Layout;
